import React from 'react';
import { StyleSheet, View } from 'react-native';
import MainLayout from '../../../layouts/dashboard/MainLayout';
import ModuleContentView from '../../../layouts/dashboard/ModuleContentView';
import { Title, Paragraph } from '../../../components/texts';
import { Button } from '../../../components/buttons';
import { Colors } from '../../../styles/theme';
import { useNavigation, useRoute } from '@react-navigation/native';
import { ROUTES } from '../../../router/Routes';
import { useSnackBarContext } from '../../../providers/SnackBarProvider';
import { DefaultService } from '../../../generated/api';
import { useUserContext } from '../../../providers/UserProvider';
import { useAuthContext } from '../../../providers/AuthProvider';
import { useQuery } from '@tanstack/react-query';

const ConfirmNewPatientScreen = (): React.ReactElement => {
  const userContext = useUserContext();
  const authContext = useAuthContext();
  const route = useRoute();
  const params = route.params as any;
  const { navigate } = useNavigation();
  const [loading, setLoading] = React.useState(false);

  const departmentDemands = useQuery(
    ['departmentDemands', authContext.authState.token],
    async () => {
      if (!authContext.authState.token) return null;
      return DefaultService.getDepartmentDemandsCaregiver(
        `Bearer ${authContext.authState.token}`,
        userContext.userState.profile?.currentDepartment
      );
    },
    {
      refetchInterval: 10000,
    }
  );

  const takeDemand = async (id: string) => {
    setLoading(true);
    await DefaultService.acceptDemand(
      `Bearer ${authContext.authState.token}`,
      userContext.userState.profile?.currentDepartment,
      id
    );
    await departmentDemands.refetch();
    navigate(ROUTES.HOME_SCREEN.name);
    setLoading(false);
  };

  const refuseDemand = async (id: string) => {
    setLoading(true);
    await DefaultService.refuseDemand(
      `Bearer ${authContext.authState.token}`,
      userContext.userState.profile?.currentDepartment,
      id
    );
    await departmentDemands.refetch();
    navigate(ROUTES.HOME_SCREEN.name);
    setLoading(false);
  };

  React.useEffect(() => {
    if (params) {
      console.log(params);
    }
  }, [params]);

  return (
    <MainLayout backButton serviceCard>
      <ModuleContentView>
        <View style={styles.container}>
          <Title h2 black mvXS center>
            C'est la première demande de{' '}
            <Title h1 primary mvXS>
              {params.request?.patient?.name}
            </Title>
          </Title>
          <View style={styles.textContainer}>
            <Paragraph>
              En prenant en charge cette demande, vous autorisez le patient à vous envoyer d’autres demandes depuis sa
              position (<Paragraph primary>{params.request && params.request?.position?.name}</Paragraph>)
            </Paragraph>
          </View>

          <View style={styles.buttonContainer}>
            <Button
              label="Je m'en occupe"
              loading={loading}
              acceptrequest
              onPress={() => takeDemand(params.demandId)}
              secondary
            />
          </View>
          <View style={styles.buttonContainer}>
            <Button
              label="Refuser"
              loading={loading}
              acceptrequest
              onPress={() => refuseDemand(params.demandId)}
              defaut
            />
          </View>
        </View>
      </ModuleContentView>
    </MainLayout>
  );
};

export { ConfirmNewPatientScreen };

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginVertical: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
  },
  textContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    padding: 20,
    marginVertical: 10,
  },
  textDangerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: '#f3a9ba',
    borderRadius: 20,
    width: '100%',
    padding: 20,
    marginVertical: 10,
    borderColor: Colors.SECONDARY,
    borderWidth: 1,
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
  },
});
